<script setup>
import PdfViewer from '@templates/pdfViewer/PdfViewer.vue';
import { url } from '@/config/urls';
import { useRoute } from 'vue-router';

const route = useRoute();
const splitSiteCode = route.query.splitSiteCode ?? null;
</script>

<template>
    <PdfViewer title="ENIF-club利用規約" :api-url=url.api.enifClubTerms.pdf :params="{ splitSiteCode }"/>
</template>